export default {
    props: {
        disabled: {
            type: Boolean,
            required: false
        },
        loading: {
            type: Boolean,
            required: false
        },
        full: {
            type: Boolean,
            required: false
        },
        small: {
            type: Boolean,
            required: false
        },
        fill: {
            type: Boolean,
            required: false
        },
        iconLeft: {
            type: Boolean,
            required: false
        },
        outline: {
            type: Boolean,
            required: false
        },
        outlinePrimary: {
            type: Boolean,
            required: false
        },
        secondary: {
            type: Boolean,
            required: false
        },
        hide: {
            type: Boolean,
            required: false
        },
        icon: {
            type: Boolean,
            required: false
        },
        iconArrowLeft: {
            type: Boolean,
            required: false
        },
        iconArrowRight: {
            type: Boolean,
            required: false
        },
        iconArrowTop: {
            type: Boolean,
            required: false
        },
        iconArrowBottom: {
            type: Boolean,
            required: false
        },
        iconHome: {
            type: Boolean,
            required: false
        },
        iconTicket: {
            type: Boolean,
            required: false
        }
    }
}
